import React, { useState } from 'react';
import { getLoggedInUser } from "../../../../helpers/authUtils";
import IconSearch from '../../../../assets/svg/ic-actions-search.svg';
import moment from 'moment';
import Popup from "reactjs-popup";
import ConfirmModal from '../../../../gb-components/ConfirmModal';
import { updateCirurgia } from '../../../../Libs/cirurgia'
import {
    firebaseFire as Libfirebase,
} from "../../../../helpers/firebase-config.js";


const CardCirurgia = ({ interacao, paciente, profissional, DataCriacao, idCirurgia, Cancelada, Concluida, DataCirurgia, Hora, HoraCirurgia, Hospital, SolicitarMaterial, OpenModal, Procedimento, cirurgia, carregar, contexto }) => {

    const [profNome, setProfNome] = useState('');
    const [isVisibleSend, setIsVisibleSend] = useState(false);
    const [novaData, setNovaData] = useState({
        data: moment().format("YYYY-MM-DD"),
        hora: moment().format("HH:mm")
    })
    const [confirmar, setConfirmar] = useState(false);
    const [confirmAction, setConfirmAction] = useState();
    const [confirmText, setConfimText] = useState({ title: '', text: '', confirmButtonText:'Sim, tenho certeza'});
    const [cancelButton, setCancelButton] = useState(true);


    const sending = false;

    const renderBody = () => {
        return (
            <div>
                {Hospital ? (
                    <p><strong>Hospital: </strong> {Hospital}</p>
                ) : null}{" "}
                {Procedimento ? (
                    <p><strong>Procedimento: </strong>{Procedimento}</p>
                ) : null}
                {DataCirurgia ? (
                    <p><strong>Data da Cirurgia: </strong> {moment(DataCirurgia).format("DD/MM/YYYY")}</p>
                ) : null}
                {HoraCirurgia ? (
                    <p><strong>Horário da Cirurgia: </strong>{HoraCirurgia}</p>
                ) : null}{" "}
                {SolicitarMaterial ? (
                    <p><strong>Solicitar Material: </strong>{SolicitarMaterial}</p>
                ) : null}
                {" "}
                <p><strong>Situação:</strong> {cirurgia.cirurgia.realizada ? (<span className="text-success">
                    <i className="fa fa-check"/> REALIZADA
                </span>) : cirurgia.cirurgia.cancelada ? (<span className="text-danger">
                    <i className="fa fa-ban" /> CANCELADA
                    </span>) : (<span className="text-info">
                        <i className="fa fa-clock" /> AGUARDANDO CIRURGIA
                    </span>)}</p>

            </div>
        )
    }



    const _reagendar = (ev) => {
        console.log(paciente, idCirurgia, cirurgia);
        setConfirmar(true);
        setConfimText({ title: "Você tem certeza?", text: "Você tem certeza que deseja " + (DataCirurgia ? 're-agendar' : 'agendar') + "?", confirmButtonText: 'Sim, tenho certeza' });
        setConfirmAction("agendar");
        setCancelButton(true);
    }
    const _concluida = (ev) => {
        setConfirmar(true);
        setConfimText({ title: "Você tem certeza?", text: "Você tem certeza que deseja marcar como concluída?", confirmButtonText: 'Sim, tenho certeza' });
        setConfirmAction("concluido");
        setCancelButton(true);
    }
    const _cancelada = (ev) => {
        setCancelButton(true);
        setConfirmar(true);
        setConfirmAction("cancelar");
        setConfimText({ title: "Você tem certeza?", text: "Você tem certeza que deseja marcar a cirurgia como cancelada?", confirmButtonText: 'Sim, tenho certeza' });

    }
    const confirmReagendar = () => {
        let data = { HoraCirurgia: novaData.hora, DataCirurgia: novaData.data };

        updateCirurgia(paciente.id, cirurgia.id, data).then(async() => {
            await Libfirebase.collection("paciente")
                .doc(paciente.id).update({
                    status: 'Agendado'
                });
            setCancelButton(false);
            setConfirmar(true);
            setConfirmAction("reload");
            setConfimText({ title: "Concluído", text: "Cirurgia " + (DataCirurgia?"re-agendada":"agendada") + " com sucesso", confirmButtonText:'OK'  });

        })
    }
    const reload = () => {
        contexto.carregar();
    }
    const confirmConcluido = (tp = 0) => {
        let data = {
            realizada: tp === 0,
            cancelada: tp === 1,
            DataRealizada: tp === 0 ? moment().format("YYYY-MM-DD HH:mm:ss") : null,
            DataCancelada: tp === 1 ? moment().format("YYYY-MM-DD HH:mm:ss") : null,
        };
        updateCirurgia(paciente.id, cirurgia.id, data).then(async () => {
            Libfirebase.collection("paciente")
                .doc(paciente.id).update({
                    status: 'Finalizado'
                });
 
            setCancelButton(false);
            setConfirmar(true);
            setConfirmAction("reload");
            setConfimText({ title: "Concluído", text: "Cirurgia alterada para "+(tp==0?'REALIZADA':'CANCELADA')+" com sucesso", confirmButtonText: 'OK' });

        });
    }
    const confirmCanelar = () => {
        confirmConcluido(1);
    }
    const cancelConfirm = () => {
        setConfirmar(false);
    }


    return (
        <div className={"gb-card mb-3"}>
            <ConfirmModal
                open={confirmar}
                cancelButtonAction={cancelConfirm}
                title={confirmText.title}
                message={confirmText.text}
                showCancelButton={cancelButton}
                confirmButtonText={confirmText.confirmButtonText}
                confirmButtonAction={confirmAction == 'reload' ? reload : confirmAction == 'cancelar' ? confirmCanelar : confirmAction == 'agendar' ? confirmReagendar : confirmAction == 'concluido' ? () => { confirmConcluido(0) } : null} />
            <div className={getLoggedInUser().username === profissional ? "gb-card-header profissional" : "gb-card-header"}>
                <p>{profissional ? profissional : profNome}{" "}{/* {Concluida ? (<p>{Concluida}</p>) : null} */}</p>
                <div style={{ textAlign: getLoggedInUser().username === profissional ? 'right' : null, }}>
                    {DataCriacao ? (
                        <span className="gb-card-header-hora">
                            {DataCriacao.replace("-", "/").replace("-", "/")}{" "}{Hora ? Hora : ""}
                            {Concluida ? <strong> | {Concluida}</strong> : null}
                            {Cancelada ? <strong> | {Cancelada}</strong> : null}
                        </span>
                    ) : null}

                    {/* <div style={{ textAlign: getLoggedInUser().username === profissional ? 'left' : 'right' }}>

                        <a href="#" onClick={OpenModal}>
                            <img src={IconSearch} style={{ marginLeft: 15 }} />
                        </a>

                    </div> */}
                </div>


            </div>

            <div className="gb-card-body">
                {renderBody()}
            </div>

            {!Concluida && !Cancelada ? (
                <div className="gb-card-footer">


                    <div className="gb-card-footer-button bt-centered" onClick={_concluida}><i className="fa fa-check  mr-1" /> {" "}  Marcar Concluida</div>

                    <Popup
                        style={{ width: "1000px" }}
                        position="top"
                        trigger={
                            <div className="gb-card-footer-button bt-centered"><i className="far fa-calendar-check mr-1" /> {" "} {DataCirurgia ? `Re-Agendar` : 'Agendar'}</div>
                        }
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                color: "#435966"
                            }}
                        >
                            {" "}
                            <center><p><b><i className='fa fa-calendar' /> Data</b></p></center>
                            <input
                                label="Data"
                                className="form-control"
                                placeholder="Data da Cirugia"
                                type="date"
                                id="dataCirurgia"
                                value={novaData.data}
                                onChange={text =>
                                    setNovaData({ ...novaData, data: text.target.value })
                                }
                            // icone="fa fa-calendar"
                            />

                            <center><p><b><i className="fa fa-clock" /> Hora</b></p></center>
                            <input
                                className="form-control"
                                label="Hora"
                                placeholder="Hora"
                                type="time"
                                id="dataCirurgiaEdit"
                                value={novaData.hora}
                                onChange={text => {
                                    setNovaData({ ...novaData, hora: text.target.value })
                                }
                                }
                            // icone="fa fa-clock"
                            />

                            <div
                                style={{
                                    marginTop: 10,
                                    marginBottom: 10,
                                    alignSelf: "center",
                                    alignContent: "center",
                                    flex: 1
                                }}
                            >
                                <a
                                    onClick={event => _reagendar(event)}
                                    href="#"
                                    className="btn gb-button"
                                >
                                    Concluir
                                </a>
                            </div>
                        </div>
                    </Popup>

                    <div className="gb-card-footer-button" onClick={_cancelada}><i className="fa fa-ban  mr-1" /> {" "} Cirurgia Cancelada</div>

                </div>
            ) : null}

        </div>
    )
}

export default CardCirurgia;